import L from "leaflet";
import "leaflet-extra-markers";
// import "font-awesome/css/font-awesome.css";
// import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";
// import { config } from '@fortawesome/fontawesome-svg-core'
// import '@fortawesome/fontawesome-free/css/all.min.css';
import { uptimeToString } from '../../utils/converters'
import '../../styles/Icon.css'

export const problemColors = {
    "0": '#541FB3',
    "1": '#28a1d7',
    "2": '#f5bb3a',
    "3": '#ef9227',
    "4": '#d63a23',
    "5": '#a23337'
}


// config.autoAddCss = false
// отображение батареи в зависимости от напряжения
export function accDiv(complex) {
    const powerMacro = (complex.macros || []).find(item => item.macro === '{$POWER}')
    if (powerMacro && powerMacro.value === 'BAT') {
        const voltage = (complex.items || []).find(item => item.key_ === 'mssVoltage' || item.key_ === 'voltage_board' || item.key_ === "pwr")
        if (voltage) {
            const accVoltage = voltage.lastvalue
            let level = 4
            if (accVoltage < 12) level = 3
            if (accVoltage < 11.7) level = 2
            if (accVoltage < 11.3) level = 1
            return `<div className="bat-${level}"></div>`
        }
    }
    return ''
}


export function getTooltip(complex) {
    //показ значка батареи в зависимости от уровня заряда
    if ((complex.macros || []).find(macro => macro.macro === '{$POWER}')) {
        return `
            <style>
                .leaflet-tooltip {
                    position: absolute;
                    background-color: rgba(0, 0, 0, 0.1) !important;
                    border: 0px solid #000;
                    color: #000;
                    padding: 0px;
                }
                .bat-4 {
                    width: 40px;
                    height: 14px;
                    background: url('/img/battery/bat-4.png');
                    background-size: 40px;
                }
                .bat-3 {
                    width: 40px;
                    height: 14px;
                    background: url('/img/battery/bat-3.png');
                    background-size: 40px;
                }
                .bat-2 {
                    width: 40px;
                    height: 14px;
                    background: url('/img/battery/bat-2.png');
                    background-size: 40px;
                }
                .bat-1 {
                    width: 40px;
                    height: 14px;
                    background: url('/img/battery/bat-1.png');
                    background-size: 40px;
                }
                </style>
                ${accDiv(complex)}
        `
        // показ значка солнца, если питание автономное
        // if(complex.macros.find(macro => macro.macro === '{$POWER}').value === 'BAT'){
        //     return `
        //         <style>
        //             .leaflet-tooltip {
        //                 position: absolute;
        //                 background-color: rgba(0, 0, 0, 0.1) !important;
        //                 border: 0px solid #000;
        //                 color: #000;
        //                 padding: 0px;
        //             }
        //             .sun-tooltip {
        //                 width: 20px;
        //                 height: 20px;
        //                 background: url('/img/sun2.png');
        //                 background-size: 20px;
        //             }
        //         </style>
        //         <div class='sun-tooltip'>
        //         </div>
        //     `
        // }
    }

    return ''
}


export function violationsFixations(complex) {
    if ((complex.items || []).find(item => item.description === 'fixations')) {
        var tmp = (complex.items || []).filter(item => item.description === "fixations")
        // console.log(tmp.sort((a, b) => a.name.localeCompare(b.name)))
        const fixations = tmp.length > 0 ? tmp.sort((a, b) => a.name.localeCompare(b.name)).map(t => t.lastvalue).join('/') : 0;
        tmp = (complex.items || []).filter(item => item.description === "violations")
        const violations = tmp.length > 0 ? tmp.sort((a, b) => a.name.localeCompare(b.name)).map(t => t.lastvalue).join('/') : 0;
        return { violations, fixations };
    }
    return [0, 0]
}
export function violationsFixationsCODD(complex) {

    if ((complex.items || []).find(item => item.key_ === 'fixations')) {
        const fixations = (complex.items || []).filter(item => item.key_ === "fixations").length > 0 ? (complex.items || []).filter(item => item.key_ === "fixations")[0].lastvalue : 0;
        const violations = (complex.items || []).filter(item => item.key_ === "violations").length > 0 ? (complex.items || []).filter(item => item.key_ === "violations")[0].lastvalue : 0;
        return { violations, fixations };
    }


    if ((complex.items || []).find(item => item.key_ === 'total-fixations-krechet-mysql.sh[{HOST.IP}, {$MYSQL_LOGIN}, {$MYSQL_PASSWORD}]')) {
        const fixations = (complex.items || []).filter(item => item.key_ === "total-fixations-krechet-mysql.sh[{HOST.IP}, {$MYSQL_LOGIN}, {$MYSQL_PASSWORD}]").length > 0 ? (complex.items || []).filter(item => item.key_ === "total-fixations-krechet-mysql.sh[{HOST.IP}, {$MYSQL_LOGIN}, {$MYSQL_PASSWORD}]")[0].lastvalue : 0;
        const violations = (complex.items || []).filter(item => item.key_ === "total-violations-krechet-mysql.sh[{HOST.IP}, {$MYSQL_LOGIN}, {$MYSQL_PASSWORD}]").length > 0 ? (complex.items || []).filter(item => item.key_ === "total-violations-krechet-mysql.sh[{HOST.IP}, {$MYSQL_LOGIN}, {$MYSQL_PASSWORD}]")[0].lastvalue : 0;
        return { violations, fixations };
    }


    if ((complex.items || []).find(item => item.key_ === 'mssFixation')) {
        const fixations = (complex.items || []).filter(item => item.key_ === "mssFixation").length > 0 ? (complex.items || []).filter(item => item.key_ === "mssFixation")[0].lastvalue : 0;
        const violations = (complex.items || []).filter(item => item.key_ === "mssViolation").length > 0 ? (complex.items || []).filter(item => item.key_ === "mssViolation")[0].lastvalue : 0;
        return { violations, fixations };
    }


    if ((complex.items || []).find(item => item.key_ === 'todays_fixations')) {
        const fixations = (complex.items || []).filter(item => item.key_ === "todays_fixations").length > 0 ? (complex.items || []).filter(item => item.key_ === "todays_fixations")[0].lastvalue : 0;
        const violations = (complex.items || []).filter(item => item.key_ === "todays_violations").length > 0 ? (complex.items || []).filter(item => item.key_ === "todays_violations")[0].lastvalue : 0;
        return { violations, fixations };
    }

    if ((complex.items || []).find(item => item.key_ === 'count_cars')) {
        const fixations = (complex.items || []).filter(item => item.key_ === "count_cars").length > 0 ? (complex.items || []).filter(item => item.key_ === "count_cars")[0].lastvalue : 0;
        const violations = (complex.items || []).filter(item => item.key_ === "todays_violation").length > 0 ? (complex.items || []).filter(item => item.key_ === "todays_violation")[0].lastvalue : 0;
        return { violations, fixations };
    }

    if ((complex.items || []).find(item => item.key_ === 'mssFixation')) {
        const fixations = (complex.items || []).filter(item => item.key_ === "mssFixation").length > 0 ? (complex.items || []).filter(item => item.key_ === "mssFixation")[0].lastvalue : 0;
        const violations = (complex.items || []).filter(item => item.key_ === "mssViolation").length > 0 ? (complex.items || []).filter(item => item.key_ === "mssViolation")[0].lastvalue : 0;
        return { violations, fixations };
    }

    const fixations = (complex.items || []).filter(item => item.key_ === "Ptolemey.todays_passages").length > 0 ? (complex.items || []).filter(item => item.key_ === "Ptolemey.todays_passages")[0].lastvalue : 0;
    const violations = (complex.items || []).filter(item => item.key_ === "Ptolemey.todays_violations").length > 0 ? (complex.items || []).filter(item => item.key_ === "Ptolemey.todays_violations")[0].lastvalue : 0;


    return { violations, fixations };
}

export function getProblems(complex) {
    const result = []
    // console.log(complex)
    for (let trigger of complex.triggers || []) {
        let key = trigger.triggerid

        let problemName = trigger.description;
        let problemDuration = Math.round((new Date()).getTime() / 1000) - trigger.lastchange;
        // let problemNote = ''
        if (trigger.problem?.tags?.filter(tag => tag.tag === 'name')[0]) {
            problemName = trigger.problem?.tags?.filter(tag => tag.tag === 'name')[0].value
            if (problemName.includes('нет фиксаций')) {
                let item = (complex.items || []).find(item => item.key_ === 'last_fixation')
                const tag_item = trigger.problem?.tags?.find(tag => tag.tag === 'item')?.value

                if (tag_item) {
                    // console.log(complex)
                    item = (complex.items || []).find(item => item.key_ === tag_item)
                }
                if (item) {
                    problemDuration = parseInt(item.lastvalue)
                }
            } else {
                const baseTag = trigger.problem?.tags?.filter(tag => tag.tag === 'base')[0];
                if (baseTag) {
                    problemDuration = Math.floor(Date.now() / 1000) - parseInt(trigger.lastchange) + parseInt(baseTag.value);
                }
            }
            // if (problemName.includes('нет связи') && complex.items.find(item => item.key_ === 'notes' && item.lastvalue !== '')) {
            //     problemNote = ` (${complex.items.find(item => item.key_ === 'notes')?.lastvalue})`
            // }
        }

        let priority = parseInt(trigger.priority, 10)
        let problemColor = '#009549';
        switch (priority) {
            case 0: problemColor = '#541FB3'; break;
            case 1: problemColor = '#28a1d7'; break;
            case 2: problemColor = '#f5bb3a'; break;
            case 3: problemColor = '#ef9227'; break;
            case 4: problemColor = '#d63a23'; break;
            case 5: problemColor = '#a23337'; break;
            default: problemColor = '#009549'; break;
        }
        if (priority !== 0) result.push([key, complex.name, problemName, uptimeToString(problemDuration), problemColor])
    }
    return result.sort((a, b) => {
        return a[2].localeCompare(b[2])
    })
}




export function getIcon(complex, maxPriority) {
    // console.log(maxPriority)
    // let priorities = complex.triggers.map(trigger => parseInt(trigger.priority, 10));
    // if (complex.child) {
    //     complex.child.map(child => {
    //         priorities = [...priorities, ...child.triggers.map(trigger => parseInt(trigger.priority, 10))]
    //     })
    // }
    // let maxPriority = Math.max(...priorities);
    // if (!isFinite(maxPriority)) maxPriority = 0;
    // const maxPriority = getTriggerMaxPriority(complex)
    // console.log(`maxPriority : ${maxPriority}`);
    let markerColor = 'green';
    switch (maxPriority) {

        case 0: markerColor = 'green'; break;
        case 1: markerColor = 'cyan'; break;
        case 2: markerColor = 'yellow'; break;
        case 3: markerColor = 'orange'; break;
        case 4: markerColor = 'orange-dark'; break;
        case 5: markerColor = 'red'; break;
        default: markerColor = 'green'; break;
    }
    if (complex.status === "1") {
        markerColor = 'black'
    }
    // console.log(complex)


    let acknowledged = false
    let extra = ''
    let many_violations = false
        (complex.triggers || []).map(trigger => {
            if (parseInt(trigger.problem?.acknowledged) === 1) {
                acknowledged = true
            }
            if (trigger.problem?.tags?.find(tag => tag.tag === '220_down')) {
                extra = 'no_power'
            } else if (trigger.problem?.tags?.find(tag => tag.tag === 'power_off')) {
                extra = 'power_off'
            } else {
                let disabled = trigger.problem?.tags?.find(tag => tag.tag === 'disabled')
                if (disabled) {
                    switch (disabled.value) {
                        case 'all':
                            extra = 'directions_disabled_all'
                            break;
                        default:
                            extra = 'directions_disabled'
                    }
                }
            }
            if (trigger.problem?.tags?.find(tag => tag.tag === 'many_violations')) {
                many_violations = true
            }



        })

    if (complex.child) {
        // console.log(complex.childs)
        (complex.child || []).map(child => {
            (child.triggers || []).map(trigger => {
                if (parseInt(trigger.problem?.acknowledged) === 1) {
                    acknowledged = true
                }
            })
        })
    }


    // markerColor = 'violet';
    // иконка с количеством нарушений
    const { violations } = violationsFixations(complex);

    const cclass = complex.tags?.find(tag => tag.tag === 'class')
    // console.log(cclass)
    var shape = 'circle'
    switch (cclass?.value) {
        case 'crossroad':
            shape = 'square'
            break;
        case 'parking':
            shape = "penta"
            break;
        default:
            shape = 'circle'
    }

    // console.log(extra)
    // many_violations = true
    // extra = 'directions_disabled_all'

    var innerIconRight = ''
    var innerIconLeft = ''
    var innerCenter = ''
    var innerIconCenterBottom = ''

    if (acknowledged) {
        // console.log('acknowledged')
        // console.log(complex)
        innerIconRight = `
            <div class='marker-inner-icon-right'>
                <i style="scale:0.9;position: relative;margin-left:0.4px;margin-top:0;padding:0;color: brown;" class="fa fa-xs fa-cog fa-spin" aria-hidden="true"></i>
            </div>`
    }

    switch (extra) {
        case 'no_power':
            innerIconLeft = `
                <div class='marker-inner-icon-left'>
                    <i style="scale:0.8;position: relative;margin-top:0;padding:0;color: brown;" class="fa fa-xs fa-plug" aria-hidden="true"></i>
                </div>`
            break;
        case 'power_off':
            innerIconLeft = `
                    <div class='marker-inner-icon-left'>
                        <i style="scale:0.9;position: relative;margin-top:0px;padding:0;color: brown;" class="fa fa-xs fa-power-off" aria-hidden="true"></i>
                    </div>`
            break;
        case 'directions_disabled_all':
            innerIconLeft = `
                <div class='marker-inner-icon-left' >
                
                    <i style="scale:0.9;position: relative;margin-top:0;padding:0;color: brown;" class="fa fa-xs fa-arrows" aria-hidden="true"></i>
                </div>`
            break;
        case 'directions_disabled':
            innerIconLeft = `
                <div class='marker-inner-icon-left'>
                    <i style="scale:0.9;position: relative;margin-top:0;padding:0;color: brown;" class="fa fa-xs fa-arrows-h" aria-hidden="true"></i>

                </div>`
            break;

    }

    innerCenter = `<div class="marker-inner-center-text">${violations}</div>`
    if (complex.regular_task) {
        innerCenter = `<div class="marker-inner-center-circle"><div class="marker-inner-center-circle-text">${violations}</div></div>`
    }
    if (many_violations) {
        innerCenter = `
            <div class="marker-inner-center-icon">

                <i class="fa fa-xs fa-arrow-up fa-beat-fade"  style="--fa-beat-fade-scale: 1.4; padding-right: 3px" aria-hidden="true"></i>
            </div>`
        markerColor = 'purple'
    }
    var innerIcon = `${innerIconLeft}${innerIconRight}${innerIconCenterBottom}`
    var innerHTML = `
        <div class='marker-inner'>
            ${innerCenter}
            ${innerIcon}
        </div>`


    let iconMarker = L.ExtraMarkers.icon({
        markerColor,
        shape: shape,
        prefix: 'fa',
        innerHTML: innerHTML
    });


    return iconMarker;
}

export function getIconDeactivated(complex) {
    const iconSize = 40
    var svgIcon = ''
    const cclass = complex.tags?.find(tag => tag.tag === 'class') || { value: '@' }
    const fillColor = '#333'
    const borderColor = '#000'
    switch (cclass?.value) {
        case 'crossroad':
            svgIcon += `
                <div style='position:absolute; display:flex; align-self: anchor-center;'>
                    <svg width="${iconSize - 6}" height="${iconSize - 6}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                      
                        <rect class="shadow" x="10" y="10" width="80" height="80" rx="15" fill="${fillColor}" stroke="${borderColor}" stroke-width="10"  opacity="0.7" />
                    </svg>
                </div>`
            break;
        case 'parking':
            svgIcon += `
            <div style='position:absolute; display:flex; align-self: anchor-center;'>
                    <svg width="${iconSize - 4}" height="${iconSize - 4}" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                       
                        <path class="shadow" d="M 34 20 L 28 6 L 12 6 L 6 20 L 12 34 L 28 34 Z" fill="${fillColor}" stroke="${borderColor}" stroke-width="4"  opacity="0.7" stroke-linejoin="round" stroke-linecap="round" />
                    
                    </svg>
                </div>`
            break;
        case 'vgk':
            svgIcon += `
                <div style='position:absolute; display:flex; align-self: anchor-center;'>
                    <svg width="${iconSize}" height="${iconSize}"  viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                   
                        <path class="shadow" d="M 34 20 L 30 10 L 20 6 L 10 10 L 6 20 L 10 30 L 20 34 L 30 30 Z" fill="${fillColor}" stroke="${borderColor}" stroke-width="4" opacity="0.7" />
                    
                    </svg>
                </div>`
            break;
        default:
            svgIcon += `
                <div style='position:absolute; display:flex; align-self: anchor-center;'>
                    <svg width="${iconSize - 4}" height="${iconSize - 4}"  viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                        <circle class="shadow" cx="20" cy="20" r="15" fill="${fillColor}" stroke="${borderColor}" stroke-width="4" opacity="0.7" />
                    </svg>
                </div>`
            break;
    }
    const iconMarker = new L.DivIcon({
        html: svgIcon,
        className: `${cclass}_marker custom_icon`, // чтобы убрать стандартные стили
        iconSize: [44, 44], // Размер иконки
        popupAnchor: [0, 0],
        iconAnchor: [22, 22] // Координаты якоря (центр нижнего края)
    });



    return iconMarker;
}

function calculatePercentage(array) {
    const totalCount = array.length;
    const counts = array.reduce((acc, num) => {
        acc[num] = (acc[num] || 0) + 1;
        return acc;
    }, {});

    const percentages = {};
    for (const [key, value] of Object.entries(counts)) {
        percentages[key] = (value / totalCount) * 100;
    }

    return percentages;
}

function generateConicGradient(percentages) {
    // console.log(percentages)
    const colorMap = {
        0: '#008C3A',
        1: '#21A2DA',
        2: '#F4B62A',
        3: '#F28A18',
        4: '#D32D19',
        5: '#9C262A',
    }
    let gradientParts = [];
    let cumulativePercentage = 0;

    for (const [num, percent] of Object.entries(percentages)) {
        gradientParts.push(`${colorMap[num]} ${cumulativePercentage}% ${cumulativePercentage + percent}%`);
        cumulativePercentage += percent;
    }

    return `conic-gradient(${gradientParts.join(', ')})`;
}


export function getIconMarkerCluster(mcount, priorities, statuses) {
    // let markerColor = '#008C3A';
    // let gradient = ''
    // if (priorities.length > 0) {
    //     console.log(priorities)
    // console.log(priorities, statuses)
    const percentages = calculatePercentage2(priorities, true)
    // const gradient = generateConicGradient(percentages);

    const strokePercentages = calculatePercentage2(statuses)

    // }

    const icon = new L.DivIcon({
        className: 'marker-cluster-icon',
        html: `
        <div style='position:absolute; display:flex; align-self: anchor-center;'>
        <svg width="36" height="36" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                <circle class="shadow" cx="20" cy="20" r="16" fill="white" opacity="1" />
            </svg>
        </div>
        <div style='position:absolute; display:flex; align-self: anchor-center;'>
                ${createConicGradientSVGCircleFilled(percentages, 24)}
        </div>
        <div style='position:absolute; display:flex; align-self: anchor-center;'>
                ${createConicGradientSVGCircleStroked(strokePercentages, 36)}
        </div>
        <div style='position:absolute; display:flex; align-self: anchor-center;'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="350" fill="white"  lengthAdjust="spacing" text-anchor="middle" alignment-baseline="middle" font-weight="bold" " >
                    ${mcount}
                    </text>
                </svg>
            </div>
      
`,
        iconSize: [40, 40],
        iconAnchor: [20, 20]
    });
    return icon

}

function createConicGradientSVGCircleFilled(sectors, size = 50) {
    const center = 50
    const radius = 50
    let currentAngle = 0;
    if (sectors.length === 1) {
        return `<svg viewBox="0 0 100 100" width="${size}px" height="${size}px">
                    <circle cx="50" cy="50" r="50" fill="${sectors[0].color}"/>
                </svg>`
    }
    let paths = ''
    // for (let index = 0; index < sectors.length; index++) {

    sectors.map(({ angle, color }) => {
        const startAngle = (currentAngle - 90) * Math.PI / 180;
        const endAngle = (currentAngle + angle - 90) * Math.PI / 180;
        const largeArc = angle > 180 ? 1 : 0;
        // Расчет координат точек
        const x1 = center + radius * Math.cos(startAngle);
        const y1 = center + radius * Math.sin(startAngle);
        const x2 = center + radius * Math.cos(endAngle);
        const y2 = center + radius * Math.sin(endAngle);
        paths = paths + `<path d="M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1  ${x2} ${y2} Z" fill="${color}"/>`
        currentAngle += angle;
    })

    return `<svg viewBox="0 0 100 100" width="${size}px" height="${size}px">
                ${paths}
            </svg>`
}

function createConicGradientSVGCircleStroked(sectors, size = 50) {
    const center = 50
    const radius = 50
    const border = radius / 4
    let currentAngle = 0;
    if (sectors.length === 1) {
        return `<svg viewBox="0 0 100 100" width="${size}px" height="${size}px">
                    <circle cx="${center}" cy="${center}" r="${radius - (border / 2)}" fill="none" stroke="${sectors[0].color}" stroke-width="${border}"/>
                </svg>`
    }
    let paths = ''
    // for (let index = 0; index < sectors.length; index++) {

    sectors.map(({ angle, color }) => {
        const startAngle = (currentAngle - 90) * Math.PI / 180;
        const endAngle = (currentAngle + angle - 90) * Math.PI / 180;
        const largeArc = angle > 180 ? 1 : 0;
        // Расчет координат точек
        const x1 = center + radius * Math.cos(startAngle);
        const x1inner = center + (radius - border) * Math.cos(startAngle);
        const y1inner = center + (radius - border) * Math.sin(startAngle);
        const y1 = center + radius * Math.sin(startAngle);
        const x2 = center + radius * Math.cos(endAngle);
        const x2inner = center + (radius - border) * Math.cos(endAngle);
        const y2 = center + radius * Math.sin(endAngle);
        const y2inner = center + (radius - border) * Math.sin(endAngle);
        // paths = paths + `<path d="M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z" fill="${color}"/>`
        // paths = paths + `<path d="
        //     M ${x1} ${y1 + border} 
        //     L ${x1} ${y1} 
        //     A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} 
        //     L ${x2 - border} ${y2} 
        //     A ${radius - border} ${radius - border} 0 ${largeArc} 0 ${x1} ${y1 + border} 
        //     Z" fill="${color}"/>`
        paths = paths + `<path d="
            M ${x1inner} ${y1inner} 
            L ${x1} ${y1} 
            A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} 
            L ${x2inner} ${y2inner} 
            A ${radius - border} ${radius - border} 0 ${largeArc} 0 ${x1inner} ${y1inner} 
            Z" fill="${color}"/>`
        currentAngle += angle;
    })

    return `<svg viewBox="0 0 100 100" width="${size}px" height="${size}px">
                ${paths}
            </svg>`
}

function calculatePercentage2(array, isSeverity = false) {
    // console.log(array)
    const totalCount = array.length;
    const counts = array.reduce((acc, num) => {
        acc[num] = (acc[num] || 0) + 1;
        return acc;
    }, {});

    const pautina_status_colors = {
        "-1": '#000000',
        "0": '#007821',
        "1": '#A87E1D',
        "2": '#A3400F'
    }

    const severity_status_colors = {
        "0": '#008C3A',
        "1": '#21A2DA',
        "2": '#F4B62A',
        "3": '#F28A18',
        "4": '#D32D19',
        "5": '#9C262A',
    }



    const percentages = [];
    for (const [key, value] of Object.entries(counts)) {
        // percentages.push({ angle: (value / totalCount) * 360, color: colorMap[key], type: key })
        percentages.push({
            angle: (value / totalCount) * 360,
            color: isSeverity ? (severity_status_colors[key] || '#000000') : (pautina_status_colors[key] || '#000000'),
            type: key
        })
        // percentages[key] = (value / totalCount) * 360;
    }

    return percentages;
}


export function getIconMarkerClusterOthers(mcount, type, statuses) {
    // let markerColor = '#008C3A';
    // let gradient = ''
    // if (priorities.length > 0) {
    //     console.log(priorities)
    const percentages = calculatePercentage2(statuses)
    // const gradient = generateConicGradient(percentages);
    // }
    // console.log(statuses)

    const icon = new L.DivIcon({
        className: 'marker-cluster-icon',
        html: `
       
        <div style='position:absolute; display:flex; align-self: anchor-center;'>
            <svg width="36" height="36" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                <circle class="shadow" cx="20" cy="20" r="16" fill="#1a365d" opacity="1" />
            </svg>
        </div>
        <div style='position:absolute; display:flex; align-self: anchor-center;'>
                        ${createConicGradientSVGCircleStroked(percentages, 32)}
                    </div>
        <div style='position:absolute; display:flex; align-self: anchor-center;'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="400" fill="white" lengthAdjust="spacing" text-anchor="middle" alignment-baseline="middle" font-weight="bold" " >
                    
                    ${type[1]}
                    </text>
                </svg>
            </div>
        <div style='position:absolute; display:flex; bottom: 0; left: 0;'>
            <svg width="16" height="16" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="20" fill="#555"  opacity="0.8" />
            </svg>
        </div>
        <div style='position:absolute; display: flex; bottom: 0; left: 0; '>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="300" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${mcount > 100 ? 430 : 330}" alignment-baseline="middle" font-style="bold" >
                    ${mcount}
                    </text>
                </svg>
            </div>   
        `,
        iconSize: [36, 36],
        iconAnchor: [18, 18]
    });
    return icon

}

function createVehicleIconSVG(name, markerColor, course, speed, isMoving) {
    const namePart = name ? name.split(' / ')[1] : '';
    const rotation = course ? parseInt(course) : 0;

    // Очищаем цвет от точки с запятой если есть
    const cleanColor = markerColor.replace(';', '');

    let html = '';

    // Название сверху в полупрозрачном контейнере с обводкой
    if (namePart) {
        const textWidth = Math.max(namePart.length * 7 + 12, 40);
        html += `
            <div style='position:absolute; top: 0; left: 50%; transform: translateX(-50%); margin-top: -8px; z-index: 500; pointer-events: none;'>
                <svg width="${textWidth}" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${textWidth} 18">
                    <rect 
                        x="1" 
                        y="1" 
                        width="${textWidth - 2}" 
                        height="16" 
                        rx="8"
                        fill-opacity="0.7" 
                        fill="rgba(0, 0, 0, 0.85)" 
                        stroke="${cleanColor}" 
                        stroke-width="2"
                    />
                    <text 
                        x="${textWidth / 2}" 
                        y="13" 
                        font-family="Arial, sans-serif"
                        font-size="11" 
                        font-weight="bold"
                        fill="#fff" 
                        text-anchor="middle"
                    >${namePart}</text>
                </svg>
            </div>
        `;
    }

    // Основной круг - полупрозрачный с цветной обводкой
    html += `
        <div style='position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex;'>
            <svg width="36" height="36" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
                <defs>
                    <filter id="vehicleShadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feDropShadow dx="0" dy="1" stdDeviation="1.5" flood-color="#000000" flood-opacity="0.3"/>
                    </filter>
                </defs>
                <!-- Полупрозрачный круг с обводкой -->
                <circle 
                    cx="18" 
                    cy="18" 
                    r="14" 
                    fill-opacity="0.7" 
                    fill="rgba(0, 0, 0, 0.85)" 
                    stroke="${cleanColor}" 
                    stroke-width="3"
                    filter="url(#vehicleShadow)"
                />
            </svg>
        </div>
    `;

    

    // Иконка автомобиля в центре
    html += `
        <div style='position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex;'>
            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path 
                    d="M64 104l0 88 96 0 0-96L72 96c-4.4 0-8 3.6-8 8zm482 88L465.1 96 384 96l0 96 162 0zm-226 0l0-96-96 0 0 96 96 0zM592 384l-16 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 104C0 64.2 32.2 32 72 32l120 0 160 0 113.1 0c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2L640 336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                    fill="white"
                />
            </svg>
        </div>
    `;

    // Скорость снизу в полупрозрачном контейнере
    if (speed !== null && speed !== undefined && speed > 0) {
        const speedText = `${speed} км/ч`;
        const speedWidth = Math.max(speedText.length * 6 + 10, 45);
        html += `
            <div style='position:absolute; bottom: 0; left: 50%; transform: translateX(-50%); margin-bottom: -12px; pointer-events: none;'>
                <svg width="${speedWidth}" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${speedWidth} 16">
                    <rect 
                        x="4" 
                        y="1" 
                        width="${speedWidth - 6}" 
                        height="14" 
                        rx="6" 
                        fill-opacity="0.7" 
                        fill="rgba(0, 0, 0, 0.85)"  
                        stroke="${cleanColor}" 
                        stroke-width="2"
                    />
                    <text 
                        x="${speedWidth / 2}" 
                        y="11.5" 
                        font-family="Arial, sans-serif"
                        font-size="10" 
                        font-weight="bold"
                        fill-opacity="1" 
                        fill="#fff" 
                        text-anchor="middle"
                    >${speedText}</text>
                </svg>
            </div>
        `;
    }

    // Стрелка направления вокруг круга (показываем только при движении)
    if (isMoving && rotation) {
        html += `
            <div style='position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(${rotation - 45}deg); display: flex; pointer-events: none; z-index: 100'>
                <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                    <!-- Стрелка направления -->
                    <path 
                        d="M 22 2 L 26 10 L 22 9 L 18 10 Z"
                        fill="${cleanColor}"
                        stroke="#fff" 
                        stroke-width="1"
                    />
                </svg>
            </div>
        `;
    }

    return html;
}

export function getIconVehicle(vehicle) {
    // console.log('getIconVehicle')
    // console.log(vehicle)
    let course = (vehicle.items || []).find(item => item.key_.includes('course'))?.lastvalue
    const speed = (vehicle.items || []).find(item => item.key_.includes('speed'))?.lastvalue
    const time = (vehicle.items || []).find(item => item.key_.includes('time'))?.lastvalue

    let markerColor = '#666666' // серый по умолчанию (нет данных)
    let isMoving = false
    let speedValue = speed ? parseInt(speed) : null

    if (speed !== undefined && speed !== null) {
        if (parseInt(speed) > 0) {
            markerColor = '#0f8a0f' // зеленый - движется
            isMoving = true
        } else {
            markerColor = '#0f478a' // синий - стоит
        }
    }

    // Корректируем курс для отображения (добавляем 45 градусов для правильной ориентации)
    let displayCourse = null
    if (course) {
        displayCourse = (parseInt(course) + 45).toString()
    }

    // Проверяем актуальность данных (более 3 часов - устаревшие)
    if (time) {
        if (new Date() - new Date(parseInt(time) * 1000) > 10800 * 1000) {
            markerColor = '#9C262A' // красный - устаревшие данные
            isMoving = false
        }
    }

    const __namePart = vehicle?.name ? vehicle.name.split(' / ')[1] : '';
    const __cacheKey = `veh:${vehicle?.hostid || vehicle?.id || vehicle?.name || ''}|c:${course || ''}|s:${speed || ''}|t:${time || ''}|mc:${markerColor}|mv:${isMoving}|n:${__namePart}`;

    return __getCachedDivIcon(__cacheKey, () => L.divIcon({
        className: 'vehicle-div-icon',
        html: createVehicleIconSVG(vehicle.name || '', markerColor, displayCourse, speedValue, isMoving),
        iconSize: [44, 56], // увеличенный размер для размещения названия и скорости
        iconAnchor: [22, 28], // центрируем по центру круга

    }))
}
export function getIconBattery(bp) {
    let icon = { 'classname': 'fa fa-solid fa-rotate-270 fa-battery-full', 'color': '#009549' }
    if (bp < 80) {
        icon.classname = 'fa fa-solid fa-rotate-270 fa-battery-three-quarters'
        icon.color = '#009549'
    }
    if (bp < 60) {
        icon.classname = 'fa fa-solid fa-rotate-270 fa-battery-half'
        icon.color = '#ef9227'
        // icon.color = '#f5bb3a'
    }
    if (bp < 40) {
        icon.classname = 'fa fa-solid fa-rotate-270 fa-battery-quarter'
        icon.color = '#ef9227'
    }
    if (bp < 20) {
        icon.classname = 'fa fa-solid fa-rotate-270 fa-battery-empty'
        icon.color = '#d63a23'
    }


    return <div style={{ color: icon.color, opacity: '1', scale: '1.4 1.1', padding: '5px 2px 5px' }} className={icon.classname}></div>
}

export function getIconBatteryNoData() {
    let icon = { 'classname': 'fa fa-solid fa-rotate-270 fa-battery-empty', 'color': '#d63a23' }
    let iconx = { 'classname': 'fa fa-times', 'color': '#d63a23' }
    return <div style={{ color: icon.color, opacity: '1', scale: '1.4 1.1', padding: '5px 2px 5px', position: "relative" }} className={icon.classname}>
        <div style={{ color: iconx.color, opacity: '1', scale: '1.3 1', padding: '4px 2px 4px 3px', position: "absolute", top: 0, left: 0 }} className={iconx.classname}>

        </div>
    </div>
}

export function getPowerOff() {
    return <div style={{ color: 'black', opacity: '1', scale: '1.4 1.4', padding: '5px 5px 1px 4px' }} className='fa fa-power-off'></div>
}

export function getPowerPlug() {
    return <div style={{ color: 'brown', opacity: '1', scale: '1.1 1.1', padding: '5px 5px 1px 4px' }} className='fa fa-solid fa-plug'></div>
}

export function getLogo() {
    // let icon = { 'classname': 'fa fa-solid fa-code', 'color': 'green' }

    // return <span style={{ color: icon.color, opacity: '1', scale: '1.4 1.4', padding: '5px' }} className={icon.classname}></span>
    return <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <path d="M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
            fill='green'
        /></svg>

}



export function getAcknowldgedTriggerUrl(complex) {
    const trigger = (complex.triggers || []).find(trigger => trigger.problem?.acknowledged === '1')
    if (trigger) {
        const acknowledge = trigger.problem?.acknowledges?.find(ack => ack.message.includes('https'))
        if (acknowledge) {
            return acknowledge.message
        }
    }

}

export function getNote(complex) {
    // Берем заметку из hostsData.note_for_engineer
    const note = complex.hostsData?.note_for_engineer
    if (note && note.trim() !== '') {
        return [[complex.name.split(' / ')[1], note]]
    }

    return []
}

export function getGuestNote(complex) {
    // Берем заметку для гостей из hostsData.note_for_guest
    const note = complex.hostsData?.note_for_guest
    if (note && note.trim() !== '') {
        return [[complex.name.split(' / ')[1], note]]
    }

    return []
}

export function getBitrixNote(complex) {
    if (complex.bitrix?.comment) {
        return [[complex.name.split(' / ')[1], complex.bitrix.comment]]
    }
    return []
}

// ---------------------------
// Кеш иконок (L.DivIcon/L.divIcon)
// Нужен, чтобы при частых перерендерах (moveend/zoomend) не пересоздавать icon-объекты,
// иначе MarkerClusterGroup воспринимает их как "обновление маркера" и может мигать.
// ---------------------------
const __divIconCache = new Map();
const __DIVICON_CACHE_MAX = 5000;

function __cacheSet(key, value) {
    __divIconCache.set(key, value);
    if (__divIconCache.size > __DIVICON_CACHE_MAX) {
        const firstKey = __divIconCache.keys().next().value;
        __divIconCache.delete(firstKey);
    }
}

function __getCachedDivIcon(cacheKey, factory) {
    if (!cacheKey) return factory();
    const cached = __divIconCache.get(cacheKey);
    if (cached) return cached;
    const created = factory();
    __cacheSet(cacheKey, created);
    return created;
}







export function getSVGIcon(complex, severity, pautina_status = 0, speedLimit = null) {
    const iconSize = 40
    var svgIcon = ''
    const colorMap = {
        0: '#008C3A',
        1: '#21A2DA',
        2: '#F4B62A',
        3: '#F28A18',
        4: '#D32D19',
        5: '#9C262A',
    }




    let acknowledged = false
    let extra = ''
    let many_violations = false
    // console.log(complex)

    //Если тип перекресток ищем заметки для добавления выключенных направлений
    if (complex.tags?.find(tag => tag.value === 'crossroad')) {
        let disabled = (complex.items || []).find(item => item.key_ === 'notes')?.lastvalue
        if (disabled) {
            if (disabled.toLowerCase().includes('вcе')) {
                extra = 'directions_disabled_all'
            } else {
                extra = 'directions_disabled'
            }
        }
    }

    complex.triggers?.forEach(trigger => {
        if (trigger.problem?.acknowledged && parseInt(trigger.problem.acknowledged) === 1) {
            acknowledged = true
        }
        if (trigger.problem?.tags?.find(tag => tag.tag === '220_down')) {
            extra = 'no_power'
        } else if (trigger.problem?.tags?.find(tag => tag.tag === 'power_off')) {
            // console.log(complex)
            extra = 'power_off'
            if (trigger.problem.acknowledges?.find(ack => ack.message === 'automation' || ack.message === 'power_off_by_monitoring')) {
                extra = 'power_off_auto'
            }

        }
        if (trigger.problem?.tags?.find(tag => tag.tag === 'many_violations')) {
            many_violations = true
        }



    })

    if (complex.child) {
        (complex.child || []).forEach(child => {
            child.triggers?.forEach(trigger => {
                if (trigger.problem?.acknowledged && parseInt(trigger.problem.acknowledged) === 1) {
                    acknowledged = true
                }
            })
        })
    }

    const { violations, fixations } = violationsFixations(complex);

    const cclass = complex.tags?.find(tag => tag.tag === 'class') || { value: '@' }

    const bp = (complex.items || []).find(item => item.key_ === 'bp')
    const nodata = complex.triggers?.find(trigger => trigger.problem?.tags?.find(tag => tag.tag === 'acc_nodata'))

    // ---- icon cache key (важно: включает всё, что влияет на внешний вид) ----
    const __id = complex.hostid || complex.complex || complex.id || complex.fid || complex.name || '';
    const __hasRepair = complex.bitrix?.repair ? 1 : 0;
    const __hasRegularTask = complex.bitrix?.regular_task ? 1 : 0;
    const __childRepair = complex.child && (complex.child || []).find(child => child.bitrix?.repair) ? 1 : 0;
    const __bpVal = bp?.lastvalue ?? '';
    const __nodata = nodata ? 1 : 0;
    const __ack = acknowledged ? 1 : 0;
    const __mv = many_violations ? 1 : 0;
    const __cls = cclass?.value ?? '@';
    const __viol = violations ?? '';
    const __sl = speedLimit ?? 0;
    const __cacheKey = `svg:${__id}|cls:${__cls}|sev:${severity}|pau:${pautina_status}|ack:${__ack}|ex:${extra}|mv:${__mv}|bp:${__bpVal}|nd:${__nodata}|v:${__viol}|br:${__hasRepair}|rt:${__hasRegularTask}|cr:${__childRepair}|sl:${__sl}`;
    const __cached = __divIconCache.get(__cacheKey);
    if (__cached) return __cached;

    // Определяем цвет border в зависимости от maxPriority
    let fillColor = '#1a365d'; // темно-синий по умолчанию
    let borderColor = null


    switch (severity) {
        case 0: fillColor = '#008C3A'; break; // зеленый
        case 1: fillColor = '#21A2DA'; break; // голубой
        case 2: fillColor = '#F4B62A'; break; // желтый
        case 3: fillColor = '#F28A18'; break; // оранжевый
        case 4: fillColor = '#D32D19'; break; // красный
        case 5: fillColor = '#9C262A'; break; // темно-красный
        default: fillColor = '#4CAF50'; break;
    }

    switch (pautina_status) {
        case -1: borderColor = '#000000'; break;
        case 0: borderColor = '#007821'; break;
        case 1: borderColor = '#A87E1D'; break;
        case 2: borderColor = '#7A0000'; break;
        default: borderColor = '#000000'; break;
    }



    if (many_violations) {
        // fillColor = 'purple'
        svgIcon += `
            <div style='position:absolute; display:flex; align-self: anchor-center; margin-top: -6px;'>
                <svg width="${iconSize + 16}" height="${iconSize + 16}" viewBox="0 0 100 100">
                    <circle id="ring" r="50" cx="50" cy="50" fill="#9B59B6" />
                </svg>
            </div>
        `
    }



    switch (cclass?.value) {
        case 'crossroad':
            svgIcon += `
                <div style='position:absolute; display:flex; align-self: anchor-center;'>
                    <svg width="${iconSize - 6}" height="${iconSize - 6}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                      
                        <rect class="shadow" x="10" y="10" width="80" height="80" rx="15" fill="${fillColor}" stroke="${borderColor}" stroke-width="10"  opacity="1" />
                    </svg>
                </div>`
            break;
        case 'parking':
            svgIcon += `
            <div style='position:absolute; display:flex; align-self: anchor-center;'>
                    <svg width="${iconSize - 4}" height="${iconSize - 4}" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                       
                        <path class="shadow" d="M 34 20 L 28 6 L 12 6 L 6 20 L 12 34 L 28 34 Z" fill="${fillColor}" stroke="${borderColor}" stroke-width="4"  opacity="1" stroke-linejoin="round" stroke-linecap="round" />
                    
                    </svg>
                </div>`
            break;
        case 'vgk':
            svgIcon += `
                <div style='position:absolute; display:flex; align-self: anchor-center;'>
                    <svg width="${iconSize}" height="${iconSize}"  viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                   
                        <path class="shadow" d="M 34 20 L 30 10 L 20 6 L 10 10 L 6 20 L 10 30 L 20 34 L 30 30 Z" fill="${fillColor}" stroke="${borderColor}" stroke-width="4" opacity="1" />
                    
                    </svg>
                </div>`
            break;
        default:
            svgIcon += `
                <div style='position:absolute; display:flex; align-self: anchor-center;'>
                    <svg width="${iconSize - 4}" height="${iconSize - 4}"  viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                        <circle class="shadow" cx="20" cy="20" r="15" fill="${fillColor}" stroke="${borderColor}" stroke-width="4" opacity="1" />
                    </svg>
                </div>`
            break;
    }


    if (bp) {
        // console.log(bp.toString())
        // var color = '#009549'
        var color = colorMap[0]
        var textColor = 'white'
        var h = 100
        if (bp.lastvalue <= 80) {
            // color = '#009549'
            color = colorMap[1]
            textColor = 'black'
            h = 80
        }
        if (bp.lastvalue <= 60) {
            // color = '#21A2DA'
            color = colorMap[2]
            textColor = 'black'
            h = 60
            // icon.color = '#f5bb3a'
        }
        if (bp.lastvalue <= 40) {
            // color = '#ef9227'
            color = colorMap[3]
            textColor = 'black'
            h = 40
        }
        if (bp.lastvalue <= 20) {
            // color = '#d63a23'
            color = colorMap[4]
            textColor = 'white'
            h = 20
        }
        if (nodata) {
            color = "#0800ff"
            textColor = 'white'
        }


        var content = `
            <div style='position:absolute; bottom: 0; left: 0; display: flex;' title='Заряд АКБ'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="300" fill="${textColor}" textLength="${bp.lastvalue === "100" ? 430 : 330}" lengthAdjust="spacing" text-anchor="middle" alignment-baseline="middle" font-style="bold" >
                    ${bp.lastvalue}
                    </text>
                </svg>
            </div>`


        const ba = (complex.items || []).find(item => item.key_ === 'ba')?.lastvalue
        const la = (complex.items || []).find(item => item.key_ === 'la')?.lastvalue
        // console.log(ba, la)
        if (ba && la && (ba - la) > 2) {
            // if (true){
            content += `
            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-left: 12px; margin-bottom: -2px;' title='Идет заряд АКБ'>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 448 512">
                    <path d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288l111.5 0L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L349.4 44.6z"
                        fill="white"
                        stroke="black"
                        stroke-width="45"
                    >
                </svg>
            </div>`
        }



        svgIcon += `
        <div style='position:absolute; bottom: 0; left: 0; display: flex;'>
            <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                <circle cx="256" cy="256" r="236" fill="${color}" stroke="black" stroke-width="0" fill-opacity="1"/>
            </svg>
        </div>
        ${content}
        `


    }

    var extra_svg = ''
    if (acknowledged) {
        // if (true) {
        extra_svg += `
            <div style='position:absolute; display: flex; top: 0; right: 0; ' >
                <svg  class="shadow" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 512 512">
                    <circle cx="256" cy="256" r="236" fill="white" stroke="black" stroke-width="0"/>
                </svg>
            </div>`
        if (complex.bitrix?.repair) {
            extra_svg += `
                <div style='position:absolute; display: flex; top: 0; right: 0; margin-top: 3px; margin-right: 3px;' title='На ремонте'>
                    <svg width="11" height="11" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path xmlns="http://www.w3.org/2000/svg" d="M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                            fill="${colorMap[5]}" 
                        />
                    </svg>
                </div>`
        } else {
            extra_svg += `
                <div style='position:absolute; display: flex; top: 0; right: 0;  margin-top: 2px; margin-right: 2px;' title='Проблема подтверждена'>
                    <svg  xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 512 512">
                        <path  d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
                            fill="${colorMap[5]}" 
                    />
                    </svg>
                </div>`
            if (complex.child && (complex.child || []).find(child => child.bitrix?.repair)) {
                // if (true) {
                // console.log(complex)
                extra_svg += `
                
                    <div style='position:absolute; top: 0; right: 0; display: flex;margin-top: 10px; margin-right: -5px' title='Кто то на ремонте)'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 552 552">
                            <path xmlns="http://www.w3.org/2000/svg" d="M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                                fill="white"
                                
                                stroke="black"
                                stroke-width="40" 
                            >
                        </svg>
                    </div>`
            }



        }

    }

    switch (extra) {
        case 'no_power':
            extra_svg += `
                <div style='position:absolute; display: flex; top: 0; left: 0; '>
                    <svg class="shadow" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 512 512">
                        <circle cx="256" cy="256" r="236" fill="white" stroke="black" stroke-width="0"/>
                    </svg>
                </div>
                <div style='position:absolute; top: 0; left: 0; display: flex; margin-top: 3px; margin-left: 3px' title='Электропитание отсутствует'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12"  viewBox="0 0 384 512">
                        <path d="M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2C297 398 352 333.4 352 256l0-32c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
                            fill="${colorMap[5]}"
                            
                        />
                    </svg>
                </div>`
            break;
        case 'power_off':
        case 'power_off_auto':
            extra_svg += `
                <div style='position:absolute; display: flex; top: 0; left: 0; '>
                    <svg class="shadow" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 512 512">
                        <circle cx="256" cy="256" r="236" fill="${extra === 'power_off' ? 'white' : colorMap[5]} " stroke="black" stroke-width="0"/>
                    </svg>
                </div>
                <div style='position:absolute; display: flex; top: 0; left: 0; margin-top: 2px; margin-left: 2px' 
                    title="${extra === 'power_off' ? 'Выключено вручную' : 'Выключено автоматически из-за низкого заряда АКБ'}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="-24 -24 530 530">
                        <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
                            fill="${extra === 'power_off' ? colorMap[5] : 'white'}"
                            stroke="${extra === 'power_off' ? colorMap[5] : 'white'}"
                            stroke-width="18"
                        />
                    </svg>
                </div>`

            break;
        case 'directions_disabled_all':
            extra_svg += `
                <div style='position:absolute; display: flex; top: 0; left: 0; '>
                    <svg class="shadow" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 512 512">
                        <circle cx="256" cy="256" r="236" fill="white" stroke="black" stroke-width="0"/>
                    </svg>
                </div>
                <div style='position:absolute; display: flex; top: 0; left: 0;  margin-top: 2px; margin-left:2px' title='Все направления выключены'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 512 512">
                        <path xmlns="http://www.w3.org/2000/svg" d="M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4L224 224l-114.7 0 9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L224 288l0 114.7-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4L288 288l114.7 0-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L288 224l0-114.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
                        fill="${colorMap[5]}"
                        /></svg>
                
                </div>`
            break;
        case 'directions_disabled':
            extra_svg += `
                <div style='position:absolute; display: flex; top: 0; left: 0; '>
                    <svg class="shadow" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 512 512">
                        <circle cx="256" cy="256" r="236" fill="white" stroke="black" stroke-width="0"/>
                    </svg>
                </div>
                <div style='position:absolute; display: flex; top: 0; left: 0;  margin-top: 2px; margin-left:2px' title='Выключено хотя бы одно направление'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 512 512">
                        <path xmlns="http://www.w3.org/2000/svg" d="M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                        fill="${colorMap[5]}"
                        /></svg>
                </div>`
            break;

    }


    svgIcon += `
        <div style='
            font-size: 12px;
            display: flex;
            justify-content: center; 
            z-index: 300;
            color: white;
            width: 100%;
            font-weight: bold;
        '>
            ${cclass.value === 'vgk' ? violations.split('/')[0] : violations}
        </div>
    `

    if (complex.bitrix?.regular_task) {
        extra_svg += `
                <div style='position:absolute; display: flex; bottom: 0; right: 0; '>
                    <svg class="shadow" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 512 512">
                        <circle cx="256" cy="256" r="236" fill="white" stroke="black" stroke-width="0"/>
                    </svg>
                </div>
                <div style='position:absolute; display: flex; bottom: 0; right: 0;  margin-bottom: 3px; margin-right:3px'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 -1.43 122.88 122.88">
                        <path xmlns="http://www.w3.org/2000/svg" d="M110.97,1.27L70.02,42.73l10.67,10.36l41.25-41.56C125.58,3.7,117.92-2.85,110.97,1.27L110.97,1.27z M54.04,46.81c0.4-0.31,0.81-0.58,1.22-0.81l0.15-0.08c2.35-1.28,4.81-1.24,7.39,0.53l7.17,6.98l0.11,0.11l6.6,6.42 c2.73,2.78,3.34,5.88,1.83,9.31l-19.35,50.75C24.02,112.99-0.34,87.94,0,49.73C19.23,55.35,37.75,57.19,54.04,46.81L54.04,46.81z"
                        fill="${colorMap[5]}"
                        /></svg>
                </div>
        `
    }

    if (speedLimit) {
        extra_svg += `
            <div style='position:absolute; display: flex; right: 0; margin-right: -16px; '>
                <svg class="shadow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
                    <circle cx="256" cy="256" r="230" fill="white" stroke="red" stroke-width="54"/>
                </svg>
            </div>
            
            <div style='position:absolute; display: flex; right: 0; margin-right: -15px; '>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="300" fill="black" lengthAdjust="spacing" text-anchor="middle" alignment-baseline="middle" font-style="bold" >
                    ${speedLimit}
                    </text>
                </svg>
            </div>
        `
    }


    const iconMarker = new L.DivIcon({
        html: svgIcon + extra_svg,
        className: `${cclass}_marker custom_icon`, // чтобы убрать стандартные стили
        iconSize: [44, 44], // Размер иконки
        popupAnchor: [0, 0],
        iconAnchor: [22, 22] // Координаты якоря (центр нижнего края)
    });



    return iconMarker;
}

export function pautinaStatusOreol(statuses = []) {

}

export function getOthersSVGIcon(complex, pautina_status = null, speedLimit = null) {
    let fillColor = '#1a365d'; // темно-синий по умолчанию
    let borderColor = null


    switch (pautina_status) {
        case -1: borderColor = '#000000'; break;
        case 0: borderColor = '#007821'; break;
        case 1: borderColor = '#A87E1D'; break;
        case 2: borderColor = '#A3400F'; break;
        default: borderColor = '#000000'; break;
    }
    let svgIcon = `
        <div style='position:absolute; display:flex; align-self: anchor-center;'>
            <svg width="32" height="32" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                <circle class="shadow" cx="20" cy="20" r="14" fill="${fillColor}" stroke="${borderColor}" stroke-width="4" opacity="1" />
            </svg>
        </div>
    `

    svgIcon += `
        <div style='
            font-size: 12px; 
            position:absolute; 
            display: flex; 
            justify-content: center; 
            z-index: 300;
            color: white;
            width: 100%;
            font-weight: bold;;
        '>
            ${complex.tag.slice(1, 2)}
        </div>
    `
    if (speedLimit) {
        svgIcon += `
            <div style='position:absolute; display: flex; right: 0; margin-right: -16px; '>
                <svg class="shadow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
                    <circle cx="256" cy="256" r="230" fill="white" stroke="red" stroke-width="54"/>
                </svg>
            </div>
            
            <div style='position:absolute; display: flex; right: 0; margin-right: -15px; '>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="300" fill="black" lengthAdjust="spacing" text-anchor="middle" alignment-baseline="middle" font-style="bold" >
                    ${speedLimit}
                    </text>
                </svg>
            </div>
        `
    }


    const __cacheKey = `other:${complex.tag}|pau:${pautina_status ?? ''}|sl:${speedLimit ?? 0}`;
    return __getCachedDivIcon(__cacheKey, () => new L.DivIcon({
        html: svgIcon,
        className: `${complex.tag}_marker custom_icon`, // чтобы убрать стандартные стили
        iconSize: [36, 36], // Размер иконки
        popupAnchor: [0, 0],
        iconAnchor: [18, 18]
    }))
}


export function getSVGIconVehicle(vehicle) {
    // console.log('getIconVehicle')
    // console.log(vehicle)
    var svgIcon = ''
    let course = (vehicle.items || []).find(item => item.key_.includes('course'))?.lastvalue
    const speed = (vehicle.items || []).find(item => item.key_.includes('speed'))?.lastvalue
    const time = (vehicle.items || []).find(item => item.key_.includes('time'))?.lastvalue
    // course = '90'
    // const speed = '66'
    let markerColor = '#000000'
    let border_radius = '50% 50% 50% 50%;'


    if (speed) {
        if (parseInt(speed) > 0) {
            markerColor = '#0f8a0f'
            // markerColor = '#fff'
            border_radius = '0% 50% 50% 50%;'
        }

        if (parseInt(speed) === 0) {
            // markerColor = 'rgb(15, 71, 138);'
            markerColor = '#0f478a'
        }
    }
    if (course) {
        course = (parseInt(course) + 45).toString()
    }
    if (time) {
        if (new Date() - new Date(parseInt(time) * 1000) > 10800 * 1000) {
            markerColor = '#9C262A'
        }
    }

    {/* <i class='vehicle-text' style='color:${markerColor}; border: 1px solid ${markerColor};'>${vehicle.name.split(' / ')[1]}</i>
        <div style='background-color:${markerColor}; transform: rotate(${course}deg); border-radius: ${border_radius};' class='vehicle-div'></div>
        
        <i class='fa fa-3x fa-van-shuttle' style='top: 50%; padding-top: 0px; margin-left: -6px; position: absolute; scale:0.4; z-index: 1000;'></i>
        </div> */}

    svgIcon += `
        <div style='position:absolute; top: 0; display:flex; margin-top: -30px; margin-left: -10px'>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 180 36">
                    <path d="m 13 0
                        l 150 0 
                        a 10 10 0 0 1 10 10 
                        l 0 30
                        a 10 10 0 0 1 -10 10 
                        l -150 0
                        a 10 10 0 0 1 -10 -10
                        l 0 -30
                        a 10 10 0 0 1 10 -10
                        "
                        fill="white"
                        stroke="black"
                        stroke-width="6" 
                        filter="url(#shadow1)"
                    />
                </svg>
           
        </div>
        <div style='position:absolute; top: 0; display: flex;margin-top: -30px;'>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512">
                    <text x="290" y="256" font-size="360" fill="${markerColor}" text-anchor="middle" alignment-baseline="middle" font-style="bold">
                    ${vehicle.name.split(' / ')[1]}
                    </text>
                </svg>
        </div>
        <div style='position:absolute; bottom: 0; display:flex;'>
                <svg class="shadow" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 512 512">
                <defs>
                    <filter id="shadow" x="0" y="0" width="200%" height="200%">
                        <feDropShadow dx="2" dy="2" stdDeviation="1" flood-color="#000000" flood-opacity=".8" />
                        
                    </filter>
                </defs>

                        <circle cx="256" cy="256" r="256" 
                        stroke="black" stroke-width="0"
                        fill="${markerColor}" 
                    />
                </svg>
           
        </div>`


    const icon = L.divIcon({
        className: '',
        html: svgIcon,
        iconSize: [34, 34],
        iconAnchor: [17, 34],
        popupAnchor: [0, -34]

    });
    return icon
}







